import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Box } from '@match/react-component-library';

function SearchResultsZeroState() {
  return (
    <Box display="flex" justifyContent="center" width="100%">
      <FormattedMessage {...messages.noResults} />
    </Box>
  );
}

const messages = defineMessages({
  noResults: {
    id: 'src/modules/components/SearchResults/components/ZeroState:noResults',
    description: 'no search results were found',
    defaultMessage: 'The words you searched for were not found. Try searching again.',
  },
});

export default SearchResultsZeroState;
